import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type TextChoiceType = {
  outerDiv: CSSProperties;
  textContainer: CSSProperties;
};

export const textChoiceStyles: TextChoiceType = {
  outerDiv: {
    ...cssClass.textContainerBase,
    ...cssClass.boxShadow,
    backgroundColor: backgroundColors.white,
  },

  textContainer: {
    outline: "none",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    wordBreak: "break-word",
    ...cssClass.fontFamily,
    ...cssClass.bigFont,
    ...cssClass.bigRadius,
  },
};
